/**
 * Input Filter
 */
(function ($) {
    'use strict';
    $.fn.inputFilter = function (inputFilter) {
        this.each(function (index) {
            let _this = $(this);
            if(typeof _this.data('inputFilter') === 'undefined') {
                _this.data('inputFilter', true);
                _this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
                    if (inputFilter(this)) {
                        this.oldValue = this.value;
                        this.oldSelectionStart = this.selectionStart;
                        this.oldSelectionEnd = this.selectionEnd;
                    } else if (this.hasOwnProperty("oldValue")) {
                        this.value = this.oldValue;
                        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                    }
                });
            }
        });
        return this;
    };
})(jQuery);
